var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 6C13 5.44769 12.5523 5 12 5C11.4477 5 11 5.44769 11 6V12.4142L14.7929 16.2071C15.1834 16.5977 15.8166 16.5977 16.2071 16.2071C16.5976 15.8166 16.5976 15.1834 16.2071 14.7929L13 11.5858V6Z",
    fill: "currentColor"
  })));
}

export default SvgTime;